<template>
  <v-container grid-list-xl class="fullContainer surveyPage" id="manu_385889803">
    <p v-if="canView == false">Please pass through credits to use Survey Form</p>
    <!--<v-form class="surveyForm" v-model="surveyValid" v-if="canView == true">-->
    <p v-if="fncCheckCreated()" v-html="fncCheckSuccessMessage()"></p>
    <!-- <strong>The Survey Document has been created successfully.</strong> -->
    <!--<p v-if="fncCheckCreated()">Your quote reference is: <strong>{{ fncGetQuoteNo() }}</strong></p>-->
    <center style="width: 100%;"><img style="width: 75px" class="imgLoader" src="../shared/assets/images/bwh-loader.gif" v-if="loading == true" /></center>
    <h2 v-if="formValid == false"><center>Invalid Token Authorization</center></h2>
    <h2 v-if="kamValid == false"><center>Agent User not loaded on system</center></h2>
    <h2 v-if="formExist == false && isCreated == true"><center>The Service Form does not exist</center></h2>
    <v-form class="surveyForm" v-if="formExist == true && kamValid == true && formValid == true && loading == false && canView == true && !fncCheckCreated()">
      <v-layout row wrap>
        <!--<v-flex lg12 v-if="customerSurveyType == ''">
          <h2>{{ processData.name }}</h2>
        </v-flex>-->
        <!--<v-flex lg6 style="background: #ffd600;" v-if="customerSurveyType == '' || acceptedType == false">
          <img style="margin-top: -20px;" width="90" src="https://www.builders.co.za/_ui/responsive/theme-yellow/images/Builders-responsive.jpg" />
        </v-flex>-->
        <v-flex xs12 sm12 md12 lg12 v-if="customerSurveyType == '' || acceptedType == false">
          <h2>{{ processData.name }}</h2>
        </v-flex>
        <v-flex v-if="customerSurveyType == '' || acceptedType == false">
          <p><br />Please select which type of service you require:</p>
          <v-select :items="customerSurveyTypes" v-model="customerSurveyType" placeholder="Survey Type" class="dropdown" @input="fncCheckPaymentPopup()" item-value="id" item-text="text" solo outline></v-select>
          <div v-if="serviceText != ''" v-html="fncFormatText()"></div>
          <br />
          <v-btn v-if="serviceText != ''" color="success" style="background: #333 !important; color: #fff !important;" @click.stop="fncStartForm()">Next</v-btn>
          <v-dialog v-model="dialog" width="300">
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">Callout Fee - Payment</v-card-title>
              <v-card-text v-html="fncFormatPopup()"></v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" style="background-color: #333 !important; background: #333 !important;" text @click="dialog = false">I accept</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <!--<v-flex lg4 style="background: #ffd600;" v-if="customerSurveyType != '' && acceptedType == true">
          <img style="margin-top: -20px;" width="90" src="https://www.builders.co.za/_ui/responsive/theme-yellow/images/Builders-responsive.jpg" />
          </v-flex>-->
        <v-flex lg8 v-if="customerSurveyType != '' && acceptedType == true">
          <h2>{{ processData.name }}</h2>
        </v-flex>
        <v-flex lg4 class="floatRightElement" v-if="customerSurveyType != '' && acceptedType == true">
          <v-btn v-if="loading == false" color="success" @click.stop="fncReset()">Clear and start again</v-btn>
          <v-btn v-if="loading == false" color="success" :disabled="surveyValid" @click.stop="fncSaveSurvey()">Submit Request</v-btn><br />
          <small>Please fill in all compulsory fields</small><small style="color: red !important;">*&nbsp;&nbsp;</small>
        </v-flex>
        <v-tabs v-model="activeTab" class="surveyTabs" slider-color="grey" v-if="customerSurveyType != '' && acceptedType == true">
          <v-tab ref="details" class="tab" v-if="this.storeInfoBranch == '' || this.clientInfoContact == '' || this.clientInfoCell == '' || this.clientInfoCoName == '' || this.clientInfoCoSurname == '' || this.clientInfoEmail == '' || this.clientPmoc == '' || this.clientInfoTel == ''" :key="1" ripple >Client Info <span style="padding-left: 4px;color: red; font-size:15px;">*</span></v-tab>
          <v-tab ref="details" class="tab" v-else :key="1" ripple >Client Info <span>&nbsp;</span></v-tab>
          <v-tab class="tab" ref="upload" :key="2" ripple>Upload Samples, images, plans etc.</v-tab>
          <v-tab class="tab" :id="fncGetDynamicRef(i)" ref="fncGetDynamicRef(i)" v-show="fncCheckTabDisplay( item )" v-for="(item, i) in processData.tabs" :key="i+3" ripple>{{ processData.tabs[i].name }}<span style="padding-left:4px;" v-html="fncGetDynamicAsterix( i )"></span></v-tab>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4 tabItem" :key="1" :transition="false" :reverse-transition="false">
            <v-container grid-list-xl class="fullContainerSub">
              <v-layout row wrap style="margin: 0">
                <div class="mobileServiceForm" v-if="objAuthorize.manufacturer == '385889803'">
                  <label class="blackLabel" style="float: left; width: auto !important; line-height: 45px; margin-right: 5px;" v-if="customerSurveyType == ''"><span style="font-size: 15px; color:red;">*</span> Select type of service:</label>
                  <label class="blackLabel" style="float: left; width: auto !important; line-height: 45px; margin-right: 5px;" v-else>Select type of service:</label>
                  <v-select style="width: auto" :items="customerSurveyTypes" v-model="customerSurveyType" item-value="id" item-text="text" :rules="rules" placeholder="Survey Type" class="dropdown" solo outline></v-select>
                </div>
              </v-layout>
              <v-layout row wrap style="margin: 0">
                <!--<div style="width: 25%; float:left;padding: 2%;" v-if="$router.history.current.query.agentEmail != undefined">
                  <label class="blackLabel" v-if="storeInfoBranch == ''"><span style="font-size: 15px; color:red;">*</span> Store</label>
                  <label class="blackLabel" v-else>Store</label>
                  <v-select @input="fncCheckValid" :items="branchList" v-model="storeInfoBranch" :rules="rules" placeholder="Store Name" class="dropdown" item-value="id" item-text="name" autocomplete solo outline></v-select>
                </div>
                <div style="width: 25%; float:left;padding: 2%;" v-if="$router.history.current.query.agentEmail == undefined"></div>-->
                <v-flex style="width: 100%;">
                  <div v-if="$router.history.current.query.agentEmail != undefined" class="screenTip" style="margin-top: 20px; margin-bottom: 20px;margin-left: 2% !important;width: 97% !important;">
                    <span><i style="width: 30px;" class="material-icons infoIcon" slot="activator">information</i> Please select a user from the dropdown below.  Deselect the role if it is not required.
                    </span>
                  </div>
                  <v-flex v-if="item != 'NaN' && $router.history.current.query.agentEmail != undefined" lg12 v-for="(item, i) in processData.process_roles">
                    <!--<label style="width:12% !important; display: inline-block !important; float: left !important;" class="blackLabel" v-if="item != 'NaN'" v-html="fncCheckRoleLabel(item)"></label>-->
                    <div class="validHolder">
                      <v-switch @change="fncCheckValid()" :label="fncCheckRoleLabel(item)" :ref="fncGenerateSwitchRef(i)" v-model="roleSwitches[i]"></v-switch>
                    </div>
                    <v-select :ref="fncGenerateRef(i)" v-if="item != 'NaN'" @input="fncCheckValid" :items="fncGetItems(item)" v-model="linkedUsers" placeholder="Select Users" class="dropdown" item-value="id" item-text="fullname" solo multiple autocomplete></v-select>
                  </v-flex>
                </v-flex>
                <div style="float:left; clear:both;"></div>
                <div style="width: 100%;">
                  <v-layout row wrap>
                    <h3>Customer Details</h3>
                    <v-flex xs4>
                      <label class="blackLabel" v-if="clientInfoCoName == ''"><span style="font-size: 15px; color:red;">*</span> Customer’s name</label>
                      <label class="blackLabel" v-else>Customer’s name</label>
                      <v-text-field placeholder="Co Name" @input="fncCheckValid" v-model="clientInfoCoName" :rules="rules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <label class="blackLabel" v-if="clientInfoCoSurname == ''"><span style="font-size: 15px; color:red;">*</span> Customer’surname</label>
                      <label class="blackLabel" v-else>Customer’s surname</label>
                      <v-text-field placeholder="Co Name" @input="fncCheckValid" v-model="clientInfoCoSurname" :rules="rules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4 v-if="objAuthorize.manufacturer == '385889803'">
                      <label class="blackLabel" v-if="clientInfoEmail == ''"><span style="font-size: 15px; color:red;">*</span> Customer’s email address</label>
                      <label class="blackLabel" v-else>Customer’s email address</label>
                      <p v-if="$router.history.current.query.client_email != undefined" style="font-size:12px; border-radius: 5px; min-height: 40px; border: 1px solid #f1f1f1; margin: 0 5px; letter-spacing: 0.14px; color: #ccc; padding: 10px;">{{ clientInfoEmail }}</p>
                      <v-text-field v-if="$router.history.current.query.client_email == undefined" placeholder="Email" @input="fncCheckValid" v-model="clientInfoEmail" :rules="rules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4 v-if="objAuthorize.manufacturer != '385889803'">
                      <label class="blackLabel" v-if="clientInfoEmail == ''"><span style="font-size: 15px; color:red;">*</span> Customer’s email address</label>
                      <label class="blackLabel" v-else>Customer’s email address</label>
                      <v-text-field placeholder="Email" @input="fncCheckValid" v-model="clientInfoEmail" :rules="rules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <label class="blackLabel" v-if="clientInfoTel == ''"><span style="font-size: 15px; color:red;">*</span> Customer’s mobile no.</label>
                      <label class="blackLabel" v-else>Customer’s mobile no.</label>
                      <v-text-field placeholder="Tel" @input="fncCheckValid" v-model="clientInfoTel" :rules="rules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <label class="blackLabel">Company</label>
                      <v-text-field placeholder="Company" v-model="company" :rules="rules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <label class="blackLabel" v-if="$router.history.current.query.agentEmail != undefined">Project</label>
                      <v-select v-if="$router.history.current.query.agentEmail != undefined" :items="projectList" v-model="project_item" placeholder="Project" class="dropdown" item-value="id" item-text="name" solo autocomplete ></v-select>
                    </v-flex>

                    <!--<br />
                    <label class="blackLabel" v-show="surveyType == '1'">Customer Acc No</label>
                    <v-text-field v-show="surveyType == '1'" placeholder="Acc No" v-model="ClientInfoAccNo" :rules="rules" single-line solo></v-text-field>-->
                  </v-layout>
                </div>
                <div style="width: 100%;" class="mobileServiceForm">
                  <v-layout row wrap>
                    <label class="blackLabel">Customer's Address</label>
                    <v-flex xs4>
                      <v-text-field placeholder="Street No. and Name" v-model="clientAddress" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field placeholder="Complex Name and No." v-model="clientAddressTwo" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field placeholder="Suburb" v-model="clientSuburb" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field placeholder="Town" v-model="clientTown" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field placeholder="Province" v-model="clientProvince" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field placeholder="Postal Code" v-model="clientPostalCode" single-line solo></v-text-field>
                    </v-flex>
                  </v-layout>
                </div>
                <div style="width: 100%;" class="mobileServiceForm">
                  <v-layout row wrap>
                    <h3>Contact Person Details</h3>
                    <div style="width: 100%">
                      <div class="contactpersonswitch">
                        <div class="mobileServiceForm">
                          <label style="float: right; width: auto !important">Contact person and customer are the same.</label>
                          <v-switch style="float: left; width: auto; margin: 0 5px;" @change="fncCheckDetails" v-model="detailsSame"></v-switch>
                        </div>
                      </div>
                    </div>


                    <v-flex xs4>
                      <label class="blackLabel" v-if="clientInfoContact == ''"><span style="font-size: 15px; color:red;">*</span> Contact person</label>
                      <label class="blackLabel" v-else>Contact person</label>
                      <v-text-field placeholder="Contact" @input="fncCheckValid" v-model="clientInfoContact" :rules="rules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <label class="blackLabel" v-if="clientInfoCell == ''"><span style="font-size: 15px; color:red;">*</span> Contact person’s mobile no.</label>
                      <label class="blackLabel" v-else>Contact person’s mobile no.</label>
                      <v-text-field placeholder="Cell" @input="fncCheckValid" v-model="clientInfoCell" :rules="rules" single-line solo></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <label class="blackLabel" v-if="clientPmoc == ''"><span style="font-size: 15px; color:red;">*</span> Preferred method of contact</label>
                      <label class="blackLabel" v-else>Preferred method of contact</label>
                      <v-select :items="pmocList" @input="fncCheckValid" v-model="clientPmoc" :rules="rules" placeholder="Prefered Method of Contact" class="dropdown" item-value="id" item-text="name" solo outline></v-select>
                    </v-flex>
                  </v-layout>
                </div>
                <div style="width: 100%;" class="mobileServiceForm">
                  <div v-if="$router.history.current.query.agentEmail != undefined">
                    <label class="blackLabel" v-if="storeInfoBranch == ''"><span style="font-size: 15px; color:red;">*</span> Store</label>
                    <label class="blackLabel" v-else>Store</label>
                    <v-select @input="fncCheckValid" :items="branchList" v-model="storeInfoBranch" :rules="rules" placeholder="Store Name" class="dropdown" item-value="id" item-text="name" autocomplete solo outline></v-select>
                    <br />
                  </div>
                  <label class="blackLabel">Message:</label>
                  <v-text-field placeholder="Message" v-if="$router.history.current.query.agentEmail != undefined" style="height: 133px !important" v-model="clientMessage" :rules="rules" rows="10" multi-line solo></v-text-field>
                  <v-text-field placeholder="Message" v-if="$router.history.current.query.agentEmail == undefined"style="height: 155px !important" v-model="clientMessage" :rules="rules" rows="10" multi-line solo></v-text-field>
                  <v-btn @click="fncSetUploadTab()" class="blackButton">Next</v-btn>
                </div>
                <v-flex lg6 xs12 sm12 md12>
                </v-flex>

                <!--<v-flex  lg3 xs12 sm3 md4 >-->
                <v-flex v-if="$router.history.current.query.agentEmail != undefined && processData.process_roles[0] != '' && processData.process_roles[i] != 'NaN'" lg3 xs12 sm3 md4 v-for="(item, i) in processData.process_roles">

                </v-flex>

              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="2" :transition="false" :reverse-transition="false">
            <v-container grid-list-xl class="fullContainerSub">
              <v-layout row wrap>
                <v-flex lg12>
                  <div class="mobileServiceFormMini">
                    <h3>Upload Files</h3>
                    <input type="file" id="quoteFile" class="fileUpload" style="padding-top: 30px !important;padding-bottom: 30px !important;" @change="fncSetImageObj">
                    <div class="fileHolder">
                      <p>Drag & Drop / <span style="text-decoration: underline">Click to Add Files</span></p>
                      <p class="filerules"> Maximum file size allowed: <strong>{{ systemSettings[0].max_upload_size }}MB</strong><br>
                        File types supported: <strong>{{ systemSettings[0].allowed_file_types.replace(/,./g,', .') }}</strong></p>
                      <small>{{ fileName }}</small>
                    </div>
                  </div>
                  <div class="mobileServiceFormMini">
                    <!--                    <p>Please select a file to upload and click the "Upload" button to continue<br>-->
                    <!--                      Maximum file size allowed: <strong>{{ systemSettings[0].max_upload_size }}MB</strong><br>-->
                    <!--                      File types supported: <strong>{{ systemSettings[0].allowed_file_types.replace(/,./g,', .') }}</strong></p>-->
                    <!--                      <br />-->
                    <small><strong>Disclaimer: </strong><br />Please note larger files will take longer to upload. Please wait for files to finish uploading. <br />Should your file sizes exceed the allotted file size, kindly discuss this with your Representative.</small>
                  </div>

                  <v-data-table style="margin-top: 20px;float: left; clear: both;" :headers="headers" :items="surveyFiles" class="elevation-1 attachmentList" hide-actions>
                    <template slot="items" slot-scope="props">
                      <td width="60%" v-if="$router.history.current.query.agentEmail != undefined"><a>{{ props.item.original_filename }}</a></td>
                      <td width="90%" v-else ><a>{{ props.item.original_filename }}</a></td>
                      <td width="30%" v-if="$router.history.current.query.agentEmail != undefined">
                        <v-select :items="attachmentCategories" label="Attachment Category" class="surveyAttachment"  v-model="props.item.category" style="height: 35px !important" item-value="id" item-text="name" solo single-line></v-select>
                      </td>
                      <td width="10%"><a @click.prevent="fncRemoveImage(props.index)"><i class="material-icons">delete</i></a></td>
                    </template>
                  </v-data-table>
                  <p v-if="busyUploading == 1" class="waitingUpload"><strong>Uploading... Please wait...</strong></p>
                  <v-btn style="float: left;" @click="fncSetDetailsTab()" class="blackButton">Previous</v-btn>
                  <v-btn style="float: right;" @click="fncSetDynamicTabNext(99)" v-if="processData.tabs.length > 0 && fncHasDynamicNext()" class="blackButton">Next</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" v-for="(item, i) in processData.tabs" :key="i+3" :transition="false" :reverse-transition="false">
            <v-container grid-list-xl class="fullContainerSub">
              <v-layout row wrap>
                <v-flex v-bind:class="fncCheckClass(processData.tabs[i].form[n].type)" lg3 xs12 sm6 md4 v-for="(item, n) in processData.tabs[i].form">
                  <h4 style="display: block; clear: both;" v-if="processData.tabs[i].form[n].type == 'header'">{{ processData.tabs[i].form[n].label }}</h4>
                  <label class="blackLabel" v-if="processData.tabs[i].form[n].type != 'header' && processData.tabs[i].form[n].type != 'yesno'">
                    <!--<span v-if="processData.tabs[i].form[n].required == 'true' && processData.tabs[i].form[n].value == ''"><span style="color:red;font-size:15px;">*</span>&nbsp;</span>
                    <span v-if="processData.tabs[i].form[n].required == 'true' && processData.tabs[i].form[n].value != ''"></span>-->
                    <span v-if="processData.tabs[i].form[n].required == 'true'"><span style="color:red;font-size:15px;">*</span>&nbsp;</span>
                    {{ processData.tabs[i].form[n].label }}</label>
                  <label class="blackLabel" style="float: right;width:85% !important;padding-top: 5px !important;" v-if="processData.tabs[i].form[n].type != 'header' && processData.tabs[i].form[n].type == 'yesno'"><span v-if="processData.tabs[i].form[n].required == 'true'">*&nbsp;</span>{{ processData.tabs[i].form[n].label }}</label>                  
                  <v-text-field v-if="processData.tabs[i].form[n].type == 'input'" @input="fncValidateErf( processData.tabs[i].form[n] )" :placeholder="processData.tabs[i].form[n].label" @input="fncCheckValid" v-model="processData.tabs[i].form[n].value" :rules="rules" single-line solo></v-text-field>
                  <small v-if="processData.tabs[i].form[n].type == 'input' && duplicateErf == true && processData.tabs[i].form[n].label == 'Erf Number'" style="color: red; font-weight: bold;">Duplicate Erf Number.</small>
                  <v-select v-if="processData.tabs[i].form[n].type == 'select'" @input="fncCheckValid" :items="fncGetValues(processData.tabs[i].form[n].values)" v-model="processData.tabs[i].form[n].value" :placeholder="processData.tabs[i].form[n].label" class="dropdown" solo outline></v-select>
                  <v-switch v-if="processData.tabs[i].form[n].type == 'yesno'" style="width:15% !important;" @change="fncCheckValid" v-model="processData.tabs[i].form[n].value"></v-switch>
                </v-flex>
                <v-flex lg12>
                  <v-btn style="float: left;" @click="fncSetDynamicTabPrevious(i)" class="blackButton">Previous</v-btn>
                  <v-btn style="float: right;" @click="fncSetDynamicTabNext(i)" v-if="processData.tabs.length > 0 && fncCanGoNext() == true" class="blackButton">Next</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'RoleList',
  intRoleEdit: 0,
  data () {
    return {
      roleSwitches:[],
      activeTab: 0,
      acceptedType: false,
      dialog: false,
      kamValid: true,
      formExist: true,
      isCreated: false,
      loading: false,
      surveyType: '',
      customerSurveyType: '',
      customerSurveyTypes: [
        { id: 1, text: 'Contact Customer (A BWH team member will contact you)' },
        { id: 2, text: 'Request a Quote (Provide some info to receive a quote)' },
        { id: 3, text: 'Request an Onsite Visit (A BWH specialist will come out to see you)' },
        { id: 5, text: 'Request Calculator' }
      ],
      busyUploading: 0,
      serviceText: '',
      fileName: '',
      canView: true,
      surveyValid: true,
      storeInfoBranch: '',
      rules: [
        v => !!v || 'Required Field',
      ],
      storeInfoKam: this.$router.history.current.query.agentEmail != undefined ? this.$router.history.current.query.agentEmail : '',
      // storeInfoKam: '',
      /*storeInfoKamEmail: '',
      storeInfoCell: '',*/
      clientInfoCoName : '',
      clientInfoCoSurname: '',
      /*
       : this.$router.history.current.query.client_name != undefined ? this.$router.history.current.query.client_name : '',
      clientInfoCoSurname: this.$router.history.current.query.client_name != undefined ? this.$router.history.current.query.client_name : '',
      */
      clientInfoContact: '',
      // clientInfoContact: this.$router.history.current.query.client_contact != undefined ? this.$router.history.current.query.client_contact : '',
      clientInfoAccType: this.$router.history.current.query.client_acc_type != undefined ? this.$router.history.current.query.client_acc_type : '',
      ClientInfoAccNo: this.$router.history.current.query.client_acc_no != undefined ? this.$router.history.current.query.client_acc_no : '',
      clientInfoClientType: this.$router.history.current.query.client_acc_no != undefined ? this.$router.history.current.query.client_acc_no : '',
      clientInfoCell: '',
      // clientInfoCell: this.$router.history.current.query.client_cell != undefined ? this.$router.history.current.query.client_cell : '',
      clientInfoTel: this.$router.history.current.query.client_contact != undefined ? this.$router.history.current.query.client_contact : '',
      clientInfofax: this.$router.history.current.query.client_fax != undefined ? this.$router.history.current.query.client_fax : '',
      clientInfoEmail: this.$router.history.current.query.client_email != undefined ? this.$router.history.current.query.client_email : '',
      clientAddress: '',
      clientAddressTwo: '',
      clientSuburb: '',
      clientTown: '',
      clientProvince: '',
      clientPostalCode: '',
      jobInfoProjectName: '',
      jobInfoNumberOfUnits: '',
      jobInfoBuildingType: '',
      jobInfoBuildngStage: '',
      siteErfNumber: '',
      siteArea: '',
      siteCity: '',
      siteSiteConditions: '',
      siteDistanceFromBranch: '',
      siteGpsCoordsLat: '',
      siteGpsCoordsLong: '',
      siteStreetAddress: '',
      siteComplexName: '',
      siteAccess: '',
      siteSpecialInstructions: '',
      infoCheckDimensionsIndicated: false,
      infoCheckElectronicCopy: false,
      infoCheckNotesEligible: false,
      infoCheckHaveSpecifications: false,
      infoCheckHaveRevisions: false,
      infoCheckMatchExisting: false,
      infoCheckHaveDetails: false,
      infoCheckUnusualLoad: false,
      infoCheckUnusualDetails: false,
      infoCheckSpecialNeeds: false,
      plansSections: '',
      plansElevations: '',
      plansFloorPlans: '',
      plansFloorElevation: '',
      plansFloorSections: '',
      plansSectionsElevations: '',
      plansFloorSectionsElevations: '',
      plansOtherDetails: '',
      plansArchitectContactPerson: '',
      plansArchitectTel: '',
      plansArchitectCell: '',
      plansArchitectEmail: '',
      plansEngineerContactPerson: '',
      plansEngineerTel: '',
      plansEngineerCell: '',
      plansEngineerEmail: '',
      roofExtensionCovered: '',
      roofAdditionsTrussType: '',
      roofAreaTrusses: '',
      roofExposedTrussType: '',
      roofOtherNotes: '',
      roofSundriesRoofPitch: '',
      roofSundriesOverhangLength: '',
      roofSundriesFasciaType: '',
      roofSundriesBargeType: '',
      roofSundriesUnderlayType: '',
      roofSundriesOther: '',
      roofSheetingProfile: '',
      roofSheetingMaterial: '',
      roofSheetingThickness: '',
      roofSheetingColour: '',
      roofTilesProfile: '',
      roofTileColour: '',
      rooftileRidgeType: '',
      roofTileHipStarter: '',
      roofOtherCoveringNotes: '',
      roofOtherCeilingsBrandings: false,
      roofOtherGeyserPlatform: false,
      designAssistanceGeysers: '',
      designAssistanceWindloads: '',
      designAssistanceAtticStorage: '',
      installnotesSupply: false,
      installnotesSupplyNotes: '',
      installnotesTrussesBraces: false,
      installnotesTrussesBracesNotes: '',
      installnotesTrussesBracesSundries: false,
      installnotesTrussesBracesSundriesNotes: '',
      installnotesSpecialWaterpoofing: false,
      installnotesSpecialWaterpoofingNotes: '',
      installnotesCertificate: false,
      installnotesCertificateNotes: '',
      installnotesTrussesBracesSundriesCovering: false,
      installnotesTrussesBracesSundriesCoveringNotes: '',
      installnotesSpecialNotes: '',
      clientPmoc: '5',
      clientMessage: '',
      commercialOriginator: 0,
      commercialKam: 0,
      company: '',
      /*confirmClientDate: '',
      confirmClientName: '',
      confirmClientDate: '',
      confirmKamName: '',
      confirmKamDate: '',*/
      geysers: [
        { id: '200l Geyser', name: '200l Geyser' },
        { id: '300l Geyser', name: '300l Geyser' },
        { id: '> 300l Geyser', name: '> 300l Geyser' }
      ],
      surveyTypes: [
        { id: 'lead', text: 'Lead' },
        { id: 'quote_request', text: 'Quote Request' },
        { id: 'home_service', text: 'Onsite Visit' }
      ],
      windloads: [
        { id: 'Cat 1: Fully Exposed', name: 'Cat 1: Fully Exposed' },
        { id: 'Cat 2: Semi Exposed', name: 'Cat 2: Semi Exposed' },
        { id: '> Cat 3: Densely Populated ', name: 'Cat 3: Densely Populated ' }
      ],
      loads: [
        { id: 'None', name: 'None' },
        { id: 'Air Conditioners', name: 'Air Conditioners' },
        { id: 'Attic Storage', name: 'Attic Storage' },
        { id: 'Solar Geysers', name: 'Solar Geysers' },
        { id: 'Attic Domestic', name: 'Attic Domestic' },
        { id: 'Exceptions (Snow / Wind)', name: 'Exceptions (Snow / Wind)' }
      ],
      headers: [],
      buildingTypes: [
        { id: 'New', name: 'New' },
        { id: 'Extension', name: 'Extension' },
        { id: 'Renovation', name: 'Renovation' },
        { id: 'Public Building', name: 'Public Building' },
        { id: 'Other', name: 'Other' }
      ],
      buildingStages: [
        { id: 'Tender', name: 'Tender' },
        { id: 'Window Height', name: 'Window Height' },
        { id: 'Not Started', name: 'Not Started' },
        { id: 'Ground Floor', name: 'Ground Floor' },
        { id: 'Foundation', name: 'Foundation' },
        { id: 'Wall Plate', name: 'Wall Plate' }
      ],
      access: [
        { id: 'Easy', name: 'Easy' },
        { id: 'Narrow Roads', name: 'Narrow Roads' },
        { id: 'Truck Only', name: 'Truck Only' },
        { id: 'Steep Slope', name: 'Steep Slope' },
        { id: 'Trailer', name: 'Trailer' },
        { id: 'Permit', name: 'Permit' }
      ],
      pmocList: [
        { id: '5', name: 'Email & SMS' },
        { id: '2', name: 'Email' },
        { id: '3', name: 'SMS' },
        { id: '1', name: 'None' }
      ],
      processData: [],
      detailsSame: false,
      commercialKams: [],
      commercialOriginators: [],
      userPreRoleList: [],
      linkedUsers: [],
      project_item: null,
      duplicateErf: false
    }
  },
  methods: {
    fncValidateErf( obj ) {

      if( obj.label == 'Erf Number' ) {
               
        const target = String(obj.value).toLowerCase().trim();

        const list = Array.isArray(this.erfNumbers)
          ? this.erfNumbers
          : Object.values(this.erfNumbers || {});

        const exists = list.some(v => String(v).toLowerCase().trim() === target);

        if (exists) {
          this.duplicateErf = true;
        } else {
          this.duplicateErf = false;
        }
      }
      

    },
    fncGenerateSwitchRef(index) {
      return 'role_switch_' + index;
    },
    fncGenerateRef( index ) {
      return 'role_type_' + index;
    },
    fncCanGoNext() {

      var newTab = 0;

      for( var p in this.processData.tabs ) {
        if( this.fncCheckTabDisplay( this.processData.tabs[p] ) == true ) {
          newTab = p;
        }
      }
      newTab = parseInt(newTab) + 2;

      if( newTab == this.activeTab ) {
        return false;
      } else {
        return true;
      }
    },
    fncSetDynamicTabPrevious( count ){

      var newTab = parseInt(this.activeTab) - 3;

      if( newTab < 0 ) {
        this.$refs.upload.click();
      } else {

        while( this.fncCheckTabDisplay( this.processData.tabs[newTab] ) == false ) {
          if(newTab == '0') {
            this.$refs.upload.click();
            break;
          } else {
            newTab--;
            if( newTab < 0 ) {
              break;
            }
          }
        }

      }

      var tabCount = [];
      tabCount[0] = 'zero';
      tabCount[1] = 'one';
      tabCount[2] = 'two';
      tabCount[3] = 'three';
      tabCount[4] = 'four';
      tabCount[5] = 'five';
      tabCount[6] = 'six';
      tabCount[7] = 'seven';
      tabCount[8] = 'eight';
      tabCount[9] = 'nine';

      var n = 0;

      for( var t in this.processData.tabs ) {
        if( this.fncCheckTabDisplay( this.processData.tabs[t] ) == true ) {
          if( n == newTab ) {
            document.getElementById(tabCount[n]).childNodes[0].click();
          }
        }
        n++;
      }

    },
    fncHasDynamicNext() {

      for( var t in this.processData.tabs ) {
        if( this.fncCheckTabDisplay( this.processData.tabs[t] ) == true ) {
          return true;
        }
      }

      return false;

    },
    fncSetDynamicTabNext( count ){

      var newTab = parseInt(this.activeTab) - 1;

      while( this.fncCheckTabDisplay( this.processData.tabs[newTab] ) == false ) {
        newTab++;
      }

      var tabCount = [];
      tabCount[0] = 'zero';
      tabCount[1] = 'one';
      tabCount[2] = 'two';
      tabCount[3] = 'three';
      tabCount[4] = 'four';
      tabCount[5] = 'five';
      tabCount[6] = 'six';
      tabCount[7] = 'seven';
      tabCount[8] = 'eight';
      tabCount[9] = 'nine';

      var n = 0;

      for( var t in this.processData.tabs ) {
        if( this.fncCheckTabDisplay( this.processData.tabs[t] ) == true ) {
          if( n == newTab ) {
            document.getElementById(tabCount[n]).childNodes[0].click();
          }
        }
        n++;
      }

    },
    fncGetDynamicRef( count ) {

      var tabCount = [];
      tabCount[0] = 'zero';
      tabCount[1] = 'one';
      tabCount[2] = 'two';
      tabCount[3] = 'three';
      tabCount[4] = 'four';
      tabCount[5] = 'five';
      tabCount[6] = 'six';
      tabCount[7] = 'seven';
      tabCount[8] = 'eight';
      tabCount[9] = 'nine';

      return tabCount[count];

    },
    fncSetDynamicTab( tab ) {

      console.log( tab );

    },
    fncSetUploadTab() {
      this.$refs.upload.click();
    },
    fncSetDetailsTab() {
      this.$refs.details.click();
    },
    fncGetItems( roleId ) {
      var roleName = '';
      if( this.userRoles.length > 0 ) {
        for( var r in this.userRoles ) {
          if( this.userRoles[r].id == roleId ) {
            roleName = this.userRoles[r].name;
          }
        }
      }

      if( roleName != '' ) {
        if( this.userPreRoleList[roleName] ) {

          /*if( this.$router.history.current.query.agentEmail != undefined ) {
            for( var u in this.userPreRoleList[roleName] ) {
              if( this.userPreRoleList[roleName][u].email == this.$router.history.current.query.agentEmail ) {
                this.linkedUsers.push( this.userPreRoleList[roleName][u].id );
              }
            }
          }*/

          return this.userPreRoleList[roleName];
        } else {
          return [];
        }
      }

    },
    fncCheckRoleLabel( roleId ) {
      if( this.userRoles.length > 0 ) {
        for( var r in this.userRoles ) {
          if( this.userRoles[r].id == roleId ) {
            return this.userRoles[r].name;
          }
        }
      }
      return 'Role Not Set';
    },
    fncGetDynamicAsterix( index ) {

      var needsAsterix = false;
      for( var f in this.processData.tabs[index].form ) {
        if( this.processData.tabs[index].form[f].required == 'true' && this.processData.tabs[index].form[f].value == '' ) {
          needsAsterix = true;
        }
      }
      if( needsAsterix ) {
        return '<span style="font-size:15px; color: red;">* </span>';
      } else {
        return '<span></span>';
      }
    },
    fncCheckDetails() {
      if( this.detailsSame == true ) {
        this.clientInfoContact = this.clientInfoCoName + ' ' + this.clientInfoCoSurname;
        this.clientInfoCell = this.clientInfoTel;
      } else {
        this.clientInfoContact = '';
        this.clientInfoCell = '';
      }
      this.fncCheckValid();
    },
    fncFormatPopup(){
      if( this.processData.popupPayment ) {
        return '<br />' + this.processData.popupPayment.replace(/(\r\n|\n\r|\r|\n)/g, "<br>");
      } else {
        return '';
      }
    },
    fncStartForm() {
      // this.acceptedType = true;
      this.acceptedType = true;
      if( this.customerSurveyType == '5' ) {
        this.fncSaveSurvey();
      }
    },
    fncFormatText() {
      return '<br />' + this.serviceText.replace(/(\r\n|\n\r|\r|\n)/g, "<br>");
    },
    fncCheckTabDisplay( item ) {
      var toReturn = true;
      if( toReturn == true && this.$router.history.current.query.agentEmail == undefined) {
        if( item.is_client == false || item.is_client == 'false' ) {
          toReturn = false;
        }
      }
      if( item.tab_for.indexOf( String( this.customerSurveyType ) ) == -1 ) {
        toReturn = false;
      }
      return toReturn;
    },
    fncCheckClass( type ) {
      return type;
    },
    fncGetValues( valueData ) {
      return valueData.split(',');
    },
    fncCheckSuccessMessage() {
      var toReturn = '';
      var checkUrl = window.location.href.split('quoteNo=');
      var checkUrl = checkUrl[1].split('&type=');
      if( this.$router.history.current.query.agentEmail == undefined ) {
        toReturn += '<p class="success-message"><strong>Success! Your request has been submitted.</strong></p>';
        if( this.$router.history.current.query.type != undefined && this.$router.history.current.query.type == 3 ) {
          if( this.processData.hs_article_price != '0' && this.processData.hs_article_price != '' ) {
            toReturn += '<p><strong>Please go to your relevant trolley and pay for the Onsite Visit.</strong></p>';
          }
        }
        toReturn += '<p>A representative will make contact with you soon.</p>';
        toReturn += '<p>Your quote reference is: <strong>'+checkUrl[0]+'</strong></p>';
      } else {
        toReturn += '<p class="success-message"><strong>The Service Form has successfully been submitted.</strong></p>';
        if( this.$router.history.current.query.type != undefined && this.$router.history.current.query.type == 3 ) {
          if( this.processData.hs_article_price != '0' && this.processData.hs_article_price != '' ) {
            toReturn += '<p><strong>The client needs to go to their relevant trolley and pay for the Onsite Visit.</strong></p>';
          }
        }
        toReturn += '<p>Your quote reference is: <strong>'+checkUrl[0]+'</strong></p>';
      }

      // toReturn += '<a style="font-family: Montserrat,sans-serif !important;" href="#" class="formButton">Next Step</a>';
      toReturn += '<a onclick="var oldUrl = window.location.href.split(\'&created=\'); window.location.href = oldUrl[0]; location.reload(); " style="font-family: Montserrat,sans-serif !important;" href="#" class="formButton">Submit Another Request</a>';

      return toReturn;
    },
    fncGetQuoteNo() {
      var checkUrl = window.location.href.split('quoteNo=');
      return checkUrl[1];
    },
    fncCheckCreated() {
      var checkUrl = window.location.href.split('created=');
      if( checkUrl.length > 1 ) {
        return true;
      } else {
        return false;
      }
    },
    fncCheckPaymentPopup(){
      if( this.customerSurveyType == '5' ) {
        this.detailsSame = true;
        this.fncCheckDetails();
        this.serviceText = this.processData.popupCalculator;
        this.dialog = false;
      } else if( this.customerSurveyType == '1' ) {
        this.serviceText = this.processData.popupContact;
        this.dialog = false;
      } else if( this.customerSurveyType == '2' ) {
        this.serviceText = this.processData.popupRequest;
        this.dialog = false;
      } else if( this.customerSurveyType == '3' ) {
        if( this.processData.hs_article_price == '0' || this.processData.hs_article_price == 0 ) {
          this.serviceText = this.processData.popupVisit;
          this.dialog = false;
        } else {
          this.serviceText = this.processData.popupPayment;
          this.dialog = false;
        }
      }
      this.surveyValid = true;

      if( this.customerSurveyType == '' && this.clientInfoContact != '' && this.clientInfoCell != '' && this.clientPmoc != '' && this.customerSurveyType != '' && this.storeInfoBranch != '' && this.clientInfoCoName != '' && this.clientInfoCoSurname != '' && this.clientInfoTel != '' && this.clientInfoEmail != '' ) {
        this.surveyValid = false;
      }
      for( var t in this.processData.tabs ) {
        for( var f in this.processData.tabs[t].form ) {
          if( this.processData.tabs[t].form[f].required == 'true' && this.processData.tabs[t].form[f].value == '' ) {
            this.surveyValid = true;
          }
        }
      }
    },
    fncCheckValid() {

      this.surveyValid = true;

      if( this.customerSurveyType != '' && this.clientInfoContact != '' && this.clientInfoCell != '' && this.clientPmoc != '' && this.customerSurveyType != '' && this.storeInfoBranch != '' && this.clientInfoCoName != '' && this.clientInfoCoSurname != '' && this.clientInfoTel != '' && this.clientInfoEmail != '' ) {
        this.surveyValid = false;
      }
      for( var t in this.processData.tabs ) {

        if( this.processData.tabs[t].tab_for.indexOf( String( this.customerSurveyType ) ) != -1 ) {
          for( var f in this.processData.tabs[t].form ) {

            if( this.$router.history.current.query.agentEmail == undefined ) {
              // this means that it is a client we need to check if tab is for a client
              if( this.processData.tabs[t].is_client == 'true' ) {
                if( this.processData.tabs[t].form[f].required == 'true' && this.processData.tabs[t].form[f].value.trim() == '' ) {
                  this.surveyValid = true;
                }
              }
            } else {
              if( this.processData.tabs[t].form[f].required == 'true' && this.processData.tabs[t].form[f].value.trim() == '' ) {
                this.surveyValid = true;
              }
            }
          }
        }
      }

      this.fncCheckDynamicRoles();

    },
    fncCheckDynamicRoles() {

      var validCount = 0;

      if( this.$router.history.current.query.agentEmail != undefined ) {

        for( var r in this.processData.process_roles ) {

          var items = this.fncGetItems( this.processData.process_roles[r] );

          if( items.length > 0 ) {
            if( this.roleSwitches[r] == false ) {
              validCount++;
            } else {
              var hasInc = false;
              for( var i in items ) {
                if( this.roleSwitches[r] == true && this.linkedUsers.indexOf( items[i].id ) != -1 && hasInc == false ) {
                  validCount++;
                  hasInc = true;
                }
              }
            }
          }

        }

        if( validCount < this.processData.process_roles.length ) {
          this.surveyValid = true;
        }

      }
      /*
      <v-flex v-if="item != 'NaN' && $router.history.current.query.agentEmail != undefined" lg12 v-for="(item, i) in processData.process_roles">
                    <label class="blackLabel" v-if="item != 'NaN'" v-html="fncCheckRoleLabel(item)"></label>
                    <v-select :ref="fncGenerateRef(i)" v-if="item != 'NaN'" @input="fncCheckValid" :items="fncGetItems(item)" v-model="linkedUsers" placeholder="Select Users" class="dropdown" item-value="id" item-text="fullname" solo multiple autocomplete></v-select>
                  </v-flex>
      */


    },
    fncRemoveImage(key) {
      var doDelete = confirm('Are you sure you want to delete this file/image');
      if (doDelete == true) {
        this.$store.dispatch({
          type: 'fncRemoveSurveyAttachment',
          attachmentId: key
        })
      }
    },
    fncSetImageObj(e) {

      this.uploadError = false;
      var files = e.target.files[0] || e.dataTransfer.files[0];
      if( this.systemSettings[0].max_upload_size != '' || this.systemSettings[0].max_upload_size != 0 ) {
        var fivemeg = parseInt(this.systemSettings[0].max_upload_size) * 1000000;
      } else {
        var fivemeg = 5 * 1000000;
      }
      if (parseInt(files.size) > fivemeg) {
        var snackDetails = { color: 'error', message: 'Please upload a file smaller than ' + this.systemSettings[0].max_upload_size + 'MB', display: true };
        this.$store.commit('setSnack', snackDetails);
        this.busyUploading = 0;
      } else {
        var vm = this;
        var fileObj = String(files.name).split('.');
        var fileType = '.'+fileObj[fileObj.length-1];
        fileType = fileType.toLowerCase();

        if ( fileType != '.msg' && this.systemSettings[0].allowed_file_types.indexOf( fileType ) != -1 ) {
          this.fileObj = files;
          var currentInput = document.getElementById('quoteFile');
          currentInput.value = '';
          this.$store.dispatch({
            type: 'fncUploadSurveyImage',
            files: files
          })
          this.busyUploading = 1;
        } else {
          var snackDetails = { color: 'error', message: 'Please upload a valid file type', display: true };
          this.$store.commit('setSnack', snackDetails);
          this.busyUploading = 0;
        }
      }
    },
    fncReset() {
      var reloadForm = confirm("Are you sure you want to reset the form?");
      if (reloadForm == true) {
        location.reload();
      }
    },
    fncSaveSurvey() {
      this.loading = true;
      var surveyForm = {
        surveyFiles: this.surveyFiles,
        storeInfoBranch: this.storeInfoBranch,
        storeInfoKam: this.storeInfoKam,
        /*storeInfoKamEmail: this.storeInfoKamEmail,
        storeInfoCell: this.storeInfoCell,*/
        clientInfoCoName: this.clientInfoCoName,
        clientInfoCoSurname: this.clientInfoCoSurname,
        clientInfoContact: this.clientInfoContact,
        clientInfoAccType: this.clientInfoAccType,
        clientInfoAccNo: this.ClientInfoAccNo,
        clientInfoClientType: this.clientInfoClientType,
        clientInfoCell: this.clientInfoCell,
        clientInfoTel: this.clientInfoTel,
        clientAddress: this.clientAddress,
        clientAddressTwo: this.clientAddressTwo,
        clientSuburb: this.clientSuburb,
        clientTown: this.clientTown,
        clientProvince: this.clientProvince,
        clientPostalCode: this.clientPostalCode,
        clientInfofax: this.clientInfofax,
        clientInfoEmail: this.clientInfoEmail,
        commercialKam: this.commercialKam,
        commercialOriginator: this.commercialOriginator,
        // customerSurveyType: this.customerSurveyType,
        /*jobInfoProjectName: this.jobInfoProjectName,
        jobInfoNumberOfUnits: this.jobInfoNumberOfUnits,
        jobInfoBuildingType: this.jobInfoBuildingType,
        jobInfoBuildngStage: this.jobInfoBuildngStage,
        siteErfNumber: this.siteErfNumber,
        siteArea: this.siteArea,
        siteCity: this.siteCity,
        siteSiteConditions: this.siteSiteConditions,
        siteDistanceFromBranch: this.siteDistanceFromBranch,
        siteGpsCoordsLat: this.siteGpsCoordsLat,
        siteGpsCoordsLong: this.siteGpsCoordsLong,
        siteStreetAddress: this.siteStreetAddress,
        siteComplexName: this.siteComplexName,
        siteAccess: this.siteAccess,
        siteSpecialInstructions: this.siteSpecialInstructions,
        infoCheckDimensionsIndicated: this.infoCheckDimensionsIndicated,
        infoCheckElectronicCopy: this.infoCheckElectronicCopy,
        infoCheckNotesEligible: this.infoCheckNotesEligible,
        infoCheckHaveSpecifications: this.infoCheckHaveSpecifications,
        infoCheckHaveRevisions: this.infoCheckHaveRevisions,
        infoCheckMatchExisting: this.infoCheckMatchExisting,
        infoCheckHaveDetails: this.infoCheckHaveDetails,
        infoCheckUnusualLoad: this.infoCheckUnusualLoad,
        infoCheckUnusualDetails: this.infoCheckUnusualDetails,
        infoCheckSpecialNeeds: this.infoCheckSpecialNeeds,
        plansSections: this.plansSections,
        plansElevations: this.plansElevations,
        plansFloorPlans: this.plansFloorPlans,
        plansFloorElevation: this.plansFloorElevation,
        plansFloorSections: this.plansFloorSections,
        plansSectionsElevations: this.plansSectionsElevations,
        plansFloorSectionsElevations: this.plansFloorSectionsElevations,
        plansOtherDetails: this.plansOtherDetails,
        plansArchitectContactPerson: this.plansArchitectContactPerson,
        plansArchitectTel: this.plansArchitectTel,
        plansArchitectCell: this.plansArchitectCell,
        plansArchitectEmail: this.plansArchitectEmail,
        plansEngineerContactPerson: this.plansEngineerContactPerson,
        plansEngineerTel: this.plansEngineerTel,
        plansEngineerCell: this.plansEngineerCell,
        plansEngineerEmail: this.plansEngineerEmail,
        roofExtensionCovered: this.roofExtensionCovered,
        roofAdditionsTrussType: this.roofAdditionsTrussType,
        roofAreaTrusses: this.roofAreaTrusses,
        roofExposedTrussType: this.roofExposedTrussType,
        roofOtherNotes: this.roofOtherNotes,
        roofSundriesRoofPitch: this.roofSundriesRoofPitch,
        roofSundriesOverhangLength: this.roofSundriesOverhangLength,
        roofSundriesFasciaType: this.roofSundriesFasciaType,
        roofSundriesBargeType: this.roofSundriesBargeType,
        roofSundriesUnderlayType: this.roofSundriesUnderlayType,
        roofSundriesOther: this.roofSundriesOther,
        roofSheetingProfile: this.roofSheetingProfile,
        roofSheetingMaterial: this.roofSheetingMaterial,
        roofSheetingThickness: this.roofSheetingThickness,
        roofSheetingColour: this.roofSheetingColour,
        roofTilesProfile: this.roofTilesProfile,
        roofTileColour: this.roofTileColour,
        roofTileRidgeType: this.rooftileRidgeType,
        roofTileHipStarter: this.roofTileHipStarter,
        roofOtherCoveringNotes: this.roofOtherCoveringNotes,
        roofOtherCeilingsBrandings: this.roofOtherCeilingsBrandings,
        roofOtherGeyserPlatform: this.roofOtherGeyserPlatform,
        designAssistanceGeysers: this.designAssistanceGeysers,
        designAssistanceWindloads: this.designAssistanceWindloads,
        designAssistanceAtticStorage: this.designAssistanceAtticStorage,
        installnotesSupply: this.installnotesSupply,
        installnotesSupplyNotes: this.installnotesSupplyNotes,
        installnotesTrussesBraces: this.installnotesTrussesBraces,
        installnotesTrussesBracesNotes: this.installnotesTrussesBracesNotes,
        installnotesTrussesBracesSundries: this.installnotesTrussesBracesSundries,
        installnotesTrussesBracesSundriesNotes: this.installnotesTrussesBracesSundriesNotes,
        installnotesSpecialWaterpoofing: this.installnotesSpecialWaterpoofing,
        installnotesSpecialWaterpoofingNotes: this.installnotesSpecialWaterpoofingNotes,
        installnotesCertificate: this.installnotesCertificate,
        installnotesCertificateNotes: this.installnotesCertificateNotes,
        installnotesTrussesBracesSundriesCovering: this.installnotesTrussesBracesSundriesCovering,
        installnotesTrussesBracesSundriesCoveringNotes: this.installnotesTrussesBracesSundriesCoveringNotes,
        installnotesSpecialNotes: this.installnotesSpecialNotes,*/
        manufacturer: this.$router.history.current.query.manufacturer,
        process: this.$router.history.current.query.process,
        processData: this.processData,
        surveyType: this.customerSurveyType,
        clientPmoc: this.clientPmoc,
        clientMessage: this.clientMessage,
        linkedUsers: this.linkedUsers,
        project: this.project_item,
        company: this.company
        /*confirmClientName: this.confirmClientName,
        confirmClientDate: this.confirmClientDate,
        confirmKamName: this.confirmKamName,
        confirmKamDate: this.confirmKamDate*/
      }

      this.$store.dispatch({
        type: 'fncSaveSurvey',
        fields: surveyForm
      })

    }
  },
  computed: {
    ...mapGetters([
      'objAuthorize',
      'kamUsers',
      'manufacturerToken',
      'branchList',
      'surveyFiles',
      'systemSettings',
      'attachmentCategories',
      'processList',
      'formValid',
      'userRoles',
      'repUsers',
      'projectList',
      'erfNumbers'
    ])
  },
  beforeMount() {
    this.$store.dispatch('fncPopulateProjectList');

    // get_user_by_role

    if( this.$router.history.current.query.agentEmail != undefined ) {
      this.$store.dispatch({
        type: 'fncPopulateUsers',
        context: 0,
        parent: -1,
        notification: 0,
        hide_details: true
      });

      this.$store.dispatch('fncPopulateRoles');

      this.$store.dispatch('fncPopulateErf');

    }

    this.loading = true;

    this.$store.dispatch('fncPopulateProcessList', this.$router.history.current.query.manufacturer);
    this.$store.commit('fncEmptyAttachmentCategories');
    this.$store.dispatch('fncGetAttachmentCategories', this.$router.history.current.query.manufacturer);
    this.$store.dispatch('fncPopulateSettings', this.$router.history.current.query.manufacturer);

    this.$store.dispatch('fncPopulateBranchesMin', this.$router.history.current.query.manufacturer);

    if( this.$router.history.current.query.agentEmail != undefined ) {
      this.$store.dispatch('fncPopulateCommercialKams', this.$router.history.current.query.manufacturer);
      this.$store.dispatch('fncPopulateCommercialOriginator', this.$router.history.current.query.manufacturer);
    }

    if( this.$router.history.current.query.manufacturer == undefined ) {
      //if( this.$router.history.current.query.token == undefined || this.$router.history.current.query.manufacturer == undefined ) {
      this.canView = false;
    }



  },
  created() {

    if( this.$router.history.current.query.agentEmail != undefined ) {

      this.$store.dispatch('fncRetrieveKams', this.$router.history.current.query.manufacturer);

      this.surveyType = 1;
      this.headers = [{ text: 'Uploaded File', value: 'description', width: '60%' },
        { text: 'Category', value: 'category', width: '30%' },
        { text: 'Remove', value: 'description', width: '10%' }]
    } else {
      this.surveyType = 2;
      this.headers = [{ text: 'Uploaded File', value: 'description', width: '90%' },
        { text: 'Remove', value: 'description', width: '10%' }]
    }

    if( this.$router.history.current.query.formType != undefined ) {
      this.customerSurveyType = this.$router.history.current.query.formType;
    }

    this.isCreated = true;

  },
  mounted() {

    this.roleSwitches[0] = true;
    this.roleSwitches[1] = true;
    this.roleSwitches[2] = true;
    this.roleSwitches[3] = true;
    this.roleSwitches[4] = true;

    if( this.$router.history.current.query.client_name != undefined ) {

      var objName = this.$router.history.current.query.client_name.split(' ');

      if( objName.length > 1 ) {
        if( objName.length == 2 ) {
          this.clientInfoCoName = objName[0];
          this.clientInfoCoSurname = objName[1];
        } else {
          this.clientInfoCoName = objName[0];
          for( var x in objName ) {
            if( x != 0 ) {
              this.clientInfoCoSurname += objName[x] + ' ';
            }
          }
          this.clientInfoCoSurname = this.clientInfoCoSurname.trim();
        }
      }
    }


    var oldThis = this;

    /*setTimeout(function(){
      oldThis.commercialKams = oldThis.$store.state.Processes.commercialKams;
      oldThis.commercialOriginators = oldThis.$store.state.Processes.commercialOriginators;
      //oldThis.userReps = oldThis.$store.state.Processes.userReps;
      oldThis.loading = false;

      if( oldThis.storeInfoBranch == '' && oldThis.branchList.length > 0 ) {
        if( oldThis.$router.history.current.query.store != undefined ) {
          for( var b in oldThis.branchList ) {
            if( oldThis.$router.history.current.query.store == oldThis.branchList[b].code ) {
              oldThis.storeInfoBranch = oldThis.branchList[b].id;
            }
          }
        }
      }

      if( oldThis.customerSurveyTypes.length == 1 ) {
        oldThis.customerSurveyType = oldThis.customerSurveyTypes[0].id;
        oldThis.fncStartForm();
      }

    }, 3000);*/

  },
  watch: {
    systemSettings() {
      
      this.systemSettings[0].allowed_file_types = this.systemSettings[0].allowed_file_types.replace(',.msg','');
      this.systemSettings[0].allowed_file_types = this.systemSettings[0].allowed_file_types.replace('.msg,','');

    },
    customerSurveyTypes() {

      if( this.customerSurveyTypes.length == 1 ) {
        this.customerSurveyType = this.customerSurveyTypes[0].id;
        // this.fncStartForm();
      }

    },
    processData() {

      if( this.processData.process_roles != undefined ) {
        this.processData.process_roles = this.processData.process_roles.split(',');
      }

      if( this.processData.starting_rules != '' && this.processData.starting_rules != 'null' && this.processData.starting_rules != null ) {

        var statusRules = JSON.parse( this.processData.starting_rules );

        if( this.$router.history.current.query.agentEmail == undefined && statusRules.customer.length > 0 ) {

          this.customerSurveyTypes = [];
          if( statusRules.customer.indexOf('1') != -1 ) {
            this.customerSurveyTypes.push({id: 1, text: 'Contact Customer (A BWH team member will contact you)'});
          }
          if( statusRules.customer.indexOf('2') != -1 ) {
            this.customerSurveyTypes.push({id: 2, text: 'Request a Quote (Provide some info to receive a quote)'});
          }
          if( statusRules.customer.indexOf('3') != -1 ) {
            this.customerSurveyTypes.push({id: 3, text: 'Request an Onsite Visit (A BWH specialist will come out to see you)'});
          }
          if( statusRules.customer.indexOf('5') != -1 ) {
            this.customerSurveyTypes.push({id: 5, text: 'Request Calculator'});
          }

        } else if( this.$router.history.current.query.agentEmail != undefined && statusRules.other != null && statusRules.other.length > 0 ) {

          this.customerSurveyTypes = [];
          if( statusRules.other.indexOf('1') != -1 ) {
            this.customerSurveyTypes.push({id: 1, text: 'Contact Customer (A BWH team member will contact you)'});
          }
          if( statusRules.other.indexOf('2') != -1 ) {
            this.customerSurveyTypes.push({id: 2, text: 'Request a Quote (Provide some info to receive a quote)'});
          }
          if( statusRules.other.indexOf('3') != -1 ) {
            this.customerSurveyTypes.push({id: 3, text: 'Request an Onsite Visit (A BWH specialist will come out to see you)'});
          }
          if( statusRules.customer.indexOf('5') != -1 ) {
            this.customerSurveyTypes.push({id: 5, text: 'Request Calculator'});
          }

        }

        var manuCheck = this.$router.history.current.query.manufacturer;

        if( this.objAuthorize.manufacturer != '385889803' && ( manuCheck && manuCheck != '385889803' ) ) {

            this.customerSurveyTypes = [];
            //if( statusRules.other.indexOf('1') != -1 ) {
              this.customerSurveyTypes.push({id: 1, text: 'Generate Lead'});
            //}

        }

      }

      // need to check for the preset here
      if( this.customerSurveyTypes.length == 1 ) {
        this.customerSurveyType = this.customerSurveyTypes[0].id;
      }


      /*if( this.$router.history.current.query.agentEmail != undefined ) {
        this.customerSurveyTypes = [
          { id: 2, text: 'Quote Request' },
          { id: 3, text: 'Measure To Quote' }
        ]
      }*/
      /*if( this.processData.hs_article_price == '' | this.processData.hs_article_price == '0' ) {
        this.surveyTypes = [
          { id: 'lead', text: 'Lead' },
          { id: 'quote_request', text: 'Quote Request' }
        ]

        this.customerSurveyTypes = [
          { id: 1, text: 'Contact Me' },
          { id: 2, text: 'Quote Request' }
        ]
      }*/

      /*this.$store.dispatch({
        type: 'fncCheckManufacturerToken',
        token: this.processData.token,
        manufacturer: this.$router.history.current.query.manufacturer
      })*/
      /*this.$store.dispatch({
        type: 'fncCheckTokenAuth',
        manufacturer: this.$router.history.current.query.manufacturer != undefined ? this.$router.history.current.query.manufacturer : '',
        token: this.processData.token,
        process: this.$router.history.current.query.process != undefined ? this.$router.history.current.query.process : '',
        store: this.$router.history.current.query.store != undefined ? this.$router.history.current.query.store : '',
        agentEmail: this.$router.history.current.query.agentEmail != undefined ? this.$router.history.current.query.agentEmail : '',
        client_name: this.$router.history.current.query.client_name != undefined ? this.$router.history.current.query.client_name : '',
        client_contact: this.$router.history.current.query.client_contact != undefined ? this.$router.history.current.query.client_contact : '',
        client_email: this.$router.history.current.query.client_email != undefined ? this.$router.history.current.query.client_email : '',
        auth: this.$router.history.current.query.auth != undefined ? this.$router.history.current.query.auth : ''
      });*/

      this.$store.dispatch({
        type: 'fncCheckTokenAuth',
        manufacturer: this.$router.history.current.query.manufacturer != undefined ? this.$router.history.current.query.manufacturer : '',
        process: this.$router.history.current.query.process != undefined ? this.$router.history.current.query.process : '',
        store: this.$router.history.current.query.store != undefined ? this.$router.history.current.query.store : '',
        agentEmail: this.$router.history.current.query.agentEmail != undefined ? this.$router.history.current.query.agentEmail : '',
        client_name: this.$router.history.current.query.client_name != undefined ? this.$router.history.current.query.client_name : '',
        client_contact: this.$router.history.current.query.client_contact != undefined ? this.$router.history.current.query.client_contact : '',
        client_email: this.$router.history.current.query.client_email != undefined ? this.$router.history.current.query.client_email : '',
        auth: this.$router.history.current.query.auth != undefined ? this.$router.history.current.query.auth : ''
      });

      if( this.repUsers.length > 0 ) {
        for( var r in this.repUsers ){
          if( this.userPreRoleList[this.repUsers[r].roleName] == null ) {
            this.userPreRoleList[this.repUsers[r].roleName] = [];
          }
          if( this.processData.process_roles.indexOf(this.repUsers[r].roleNewId) != -1 ) {
            if( this.$router.history.current.query.agentEmail == this.repUsers[r].email ) {
              this.linkedUsers.push( this.repUsers[r].id );
            }
          }
          this.userPreRoleList[this.repUsers[r].roleName].push({ id: this.repUsers[r].id, fullname: this.repUsers[r].fullname });
        }
        if( this.processData.starting_rules != '' && this.processData.starting_rules != 'null' && this.processData.starting_rules != null ) {

          var statusRules = JSON.parse( this.processData.starting_rules );

          if( this.$router.history.current.query.agentEmail != undefined && statusRules.rolesRules != null && statusRules.rolesRules.length > 0 ) {
            for( var u in this.repUsers ) {
              if( this.repUsers[u].email == this.$router.history.current.query.agentEmail ) {
                if( statusRules.roles.indexOf(this.repUsers[u].roleNewId) != -1 ) {
                  this.customerSurveyTypes = [];
                  if( statusRules.rolesRules.indexOf('1') != -1 ) {
                    this.customerSurveyTypes.push({id: 1, text: 'Contact Customer (A BWH team member will contact you)'});
                  }
                  if( statusRules.rolesRules.indexOf('2') != -1 ) {
                    this.customerSurveyTypes.push({id: 2, text: 'Request a Quote (Provide some info to receive a quote)'});
                  }
                  if( statusRules.rolesRules.indexOf('3') != -1 ) {
                    this.customerSurveyTypes.push({id: 3, text: 'Request an Onsite Visit (A BWH specialist will come out to see you)'});
                  }
                  if( statusRules.rolesRules.indexOf('5') != -1 ) {
                    this.customerSurveyTypes.push({id: 5, text: 'Request Calculator'});
                  }
                }
              }
            }
          }

        }
      }

      //console.log('Getting Here');

      var oldThis = this;

      setTimeout(function(){
        oldThis.commercialKams = oldThis.$store.state.Processes.commercialKams;
        oldThis.commercialOriginators = oldThis.$store.state.Processes.commercialOriginators;
        //oldThis.userReps = oldThis.$store.state.Processes.userReps;
        oldThis.loading = false;

        if( oldThis.storeInfoBranch == '' && oldThis.branchList.length > 0 ) {
          if( oldThis.$router.history.current.query.store != undefined ) {
            for( var b in oldThis.branchList ) {
              if( oldThis.$router.history.current.query.store == oldThis.branchList[b].code ) {
                oldThis.storeInfoBranch = oldThis.branchList[b].id;
              }
            }
          }
        }

        if( oldThis.customerSurveyTypes.length == 1 ) {
          oldThis.customerSurveyType = oldThis.customerSurveyTypes[0].id;
          oldThis.fncStartForm();
        }

      }, 3000);

    },
    repUsers() {

      if( this.repUsers.length > 0 ) {
        for( var r in this.repUsers ){
          if( this.userPreRoleList[this.repUsers[r].roleName] == null ) {
            this.userPreRoleList[this.repUsers[r].roleName] = [];
          }
          if( this.processData.process_roles != undefined && this.processData.process_roles.indexOf(this.repUsers[r].roleNewId) != -1 ) {
            if( this.$router.history.current.query.agentEmail == this.repUsers[r].email ) {
              this.linkedUsers.push( this.repUsers[r].id );
            }
          }
          this.userPreRoleList[this.repUsers[r].roleName].push({ id: this.repUsers[r].id, fullname: this.repUsers[r].fullname, email: this.repUsers[r].email });
        }
        if( this.processData.starting_rules != '' && this.processData.starting_rules != 'null' && this.processData.starting_rules != null ) {

          var statusRules = JSON.parse( this.processData.starting_rules );

          if( this.$router.history.current.query.agentEmail != undefined && statusRules.rolesRules != null && statusRules.rolesRules.length > 0 ) {
            for( var u in this.repUsers ) {
              if( this.repUsers[u].email == this.$router.history.current.query.agentEmail ) {
                if( statusRules.roles.indexOf(this.repUsers[u].roleNewId) != -1 ) {
                  this.customerSurveyTypes = [];
                  if( statusRules.rolesRules.indexOf('1') != -1 ) {
                    this.customerSurveyTypes.push({id: 1, text: 'Contact Customer (A BWH team member will contact you)'});
                  }
                  if( statusRules.rolesRules.indexOf('2') != -1 ) {
                    this.customerSurveyTypes.push({id: 2, text: 'Request a Quote (Provide some info to receive a quote)'});
                  }
                  if( statusRules.rolesRules.indexOf('3') != -1 ) {
                    this.customerSurveyTypes.push({id: 3, text: 'Request an Onsite Visit (A BWH specialist will come out to see you)'});
                  }
                  if( statusRules.rolesRules.indexOf('5') != -1 ) {
                    this.customerSurveyTypes.push({id: 5, text: 'Request Calculator'});
                  }
                }
              }
            }
          }

        }
      }
    },
    manufacturerToken() {
      this.canView = this.manufacturerToken;
    },
    surveyFiles() {
      this.busyUploading = 0;
    },
    branchList() {
      if( this.$router.history.current.query.store != undefined ) {
        for( var b in this.branchList ) {
          if( this.$router.history.current.query.store == this.branchList[b].code ) {
            this.storeInfoBranch = this.branchList[b].id;
          }
        }
      }
    },
    kamUsers() {
      if( this.$router.history.current.query.agentEmail != undefined ) {
        for( var k in this.kamUsers ) {
          if( this.$router.history.current.query.agentEmail.toLowerCase() == this.kamUsers[k].email.toLowerCase() ) {
            this.storeInfoKam = this.kamUsers[k];
          }
        }
        if( this.storeInfoKam.userid == undefined ) {
          this.kamValid = false;
        }
      }
    },
    processList() {
      var hasForm = false;
      if( this.$router.history.current.query.process != undefined ) {
        for( var p in this.processList ) {
          if( this.processList[p].id == this.$router.history.current.query.process ) {
            this.processData = this.processList[p];
            this.processData.tabs = this.processData.tabs == '' ? [] : JSON.parse( this.processData.tabs );
            this.processData.form = this.processData.form == '' ? [] : JSON.parse( this.processData.form );
            for( var t in this.processData.tabs ) {
              for( var f in this.processData.form ) {
                if( this.processData.tabs[t].id == f ) {
                  this.processData.tabs[t].form = this.processData.form[f];
                }
              }
            }
            hasForm = true;
          }
        }
      }
      if( hasForm == false ) {
        this.formExist = false;
      }
    }
  }
}
</script>

<style scoped>
@import '../shared/assets/css/shared.css';
</style>
